import { Box } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Heading from 'components/_core/Heading';
import { CompanyCreationLegalForm } from 'features/Bento/flows/signup/machine/model';
import SignupLandbot, {
  LandbotCallbackEvent,
} from 'features/Bento/flows/signup/pages/CompanyCreationLandbot/components/SignupLandbot';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import locales from './locales';

interface CompanyCreationLandbotProps {
  legalForm: CompanyCreationLegalForm | null;
  onLandbotCallback: (event: LandbotCallbackEvent) => void;
}

const CompanyCreationLandbotPage = asBentoPage<CompanyCreationLandbotProps>(
  ({ Layout, legalForm, onLandbotCallback, onPrev }) => (
    <Layout nav={<OBNavigation onPrev={onPrev} />}>
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        paddingBottom="space-16"
      >
        <Heading marginBottom="space-24" size="lg">
          {locales.title}
        </Heading>

        <SignupLandbot
          callback={onLandbotCallback}
          customData={{
            legalform: legalForm ?? undefined,
            signupSituation: 'shine-start-company',
          }}
        />
      </Box>
    </Layout>
  ),
);

export default CompanyCreationLandbotPage;
